import { OrganizationsManager } from "@/components/Settings/OrganizationsManager";

export function SettingsOrganizations() {
  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-3xl font-bold">Organizations</h1>
        <p className="mt-2 text-muted-foreground">
          Create, update, and remove organization entries.
        </p>
      </div>
      <OrganizationsManager />
    </div>
  );
}
